import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import Neo from "@/pages/Neo";
import ProjectPage from "@/pages/ProjectPage";
import ProjectsPage from "@/pages/ProjectsPage";

function App() {
  return (
    <div className="min-h-screen bg-[#090B0E] text-slate-100">
      <div className="pointer-events-none fixed inset-0 opacity-[0.035] bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px] z-50" />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Neo />} />
          <Route path="/films" element={<ProjectsPage />} />
          <Route path="/film/:id" element={<ProjectPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
